import React from "react";
import styled from "styled-components";
import TextF8 from "../TextF8";
import Button from "./Button";

import Box from "../Box";
import { themeGet } from "styled-system";
import { SmallContainer } from "../Grid";
import SubmitButton from "../SubmitButton";

import _ from "lodash";

const Answer = styled(TextF8)`
  font-weight: normal;
  margin: 2rem 0 0;
  padding: 4px 16px;
  border-left: 4px solid
    ${props => (props.correctAnswer ? "#19CA94" : "#E02C00")};
  font-family: ${themeGet("fonts.TTNormsProRegular")};
`;

const ChoiceWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  justify-content: center;
  @media screen and (min-width: 72em) {
    flex-wrap: no-wrap;
    align-items: start;
    flex-shrink: 0;
  }
`;

export default class MultipleChoice extends React.Component {
  render() {
    const {
      quiz,
      answer,
      onSubmit,
      submitted,
      submitting,
      messages,
      rightAnswer
    } = this.props;

    const onSelected = this.props.onMultipleChoiceChange;

    if (!quiz || (!!quiz && !quiz.data)) {
      return null;
    }

    return (
      <div>
        <Box bg="#EBE9EF" py={5}>
          <SmallContainer>
            <ChoiceWrapper>
              {quiz.data.items.map(item => {
                // const choiceId = choice.id
                const buttonState = submitted
                  ? [
                      answer === item.id
                        ? [
                            // was: quiz.data.meta.right...
                            _.get(rightAnswer, 0, null) === item.id
                              ? "selected-correct"
                              : "selected-wrong"
                          ]
                        : [
                            _.get(rightAnswer, 0, null) === item.id
                              ? "not-selected-correct"
                              : "not-selected-wrong"
                          ]
                    ]
                  : [answer === item.id ? "selected" : "default"];
                return (
                  <Button
                    key={item.id}
                    buttonState={buttonState}
                    onClick={() => {
                      !submitted && onSelected(item.id);
                    }}
                  >
                    {item.title}
                  </Button>
                );
              })}
            </ChoiceWrapper>

            <Box>
              {submitted && !!messages ? (
                <Answer
                  correctAnswer={!messages.error}
                  key={`message-${quiz.id}`}
                >
                  {messages.message}
                </Answer>
              ) : (
                <Box display="flex" alignItems="center" justifyContent="center">
                  <SubmitButton
                    onSubmit={() => onSubmit()}
                    submitted={submitted}
                    submitting={submitting}
                    disabled={answer.length === 0}
                  />
                </Box>
              )}
            </Box>
          </SmallContainer>
        </Box>
      </div>
    );
  }
}
